import { render, staticRenderFns } from "./academic-plans.vue?vue&type=template&id=41249515&scoped=true&"
import script from "./academic-plans.vue?vue&type=script&lang=js&"
export * from "./academic-plans.vue?vue&type=script&lang=js&"
import style0 from "./academic-plans.vue?vue&type=style&index=0&id=41249515&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41249515",
  null
  
)

component.options.__file = "academic-plans.vue"
export default component.exports